<template>
  <div class="comment-wrapper">
    <h3 class="section-title">멘토 답글</h3>
    <div class="comment-input-wrapper">
      <div class="comment-input-user-profile background-image"
           :style="{'background-image': 'url(' + getPhotoUrl(photoUrl) + ')'}"></div>
      <div class="comment-input-box">
        <textarea v-model.trim="content" class="comment-input-box__textarea" placeholder="답글을 작성해주세요." title="답글을 작성해주세요."></textarea>
        <div class="comment-input-box__submit-box">
          <p class="comment-input-box__count">{{content_length}}/2000</p>
          <button class="comment-input-box__submit-btn" @click="addComment">등록</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'post-mentoring',
    props: ['postId', 'photoUrl'],
    data() {
      return {
        comments: [],
        content: '',
        progressing: false,
      };
    },
    computed: {
      url() {
        return `/api/counsels/posts/${this.postId}/mentoring`;
      },
      content_length() {
        if (this.content === null) {
          return 0;
        }
        return this.content.length;
      },
    },
    methods: {
      addComment() {
        if (!this.content) {
          alert('답글을 입력해 주세요.');
          return;
        }
        if (this.progressing) return;

        this.progressing = true;
        axios.post(this.url, { content: this.content }).then((res) => {
          this.comments = res.data || [];
          this.progressing = false;
          this.content = '';
          alert('멘토 답글을 작성하였습니다.');
          location.reload();
        }).catch(() => {
          alert('답글을 달 수 없습니다.');
          location.reload();
        });
      },
      getPhotoUrl(photoUrl) {
        return photoUrl || '/images/bg-my-default.png';
      },
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// PostMentoring.vue?25c98e94